// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSplitFab-MenuFab_cls1__xqR+a","cls2":"VeloSplitFab-MenuFab_cls2__NjduD VeloSplitFab-MenuFab_cls1__xqR+a"};